(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["sticky-product"] && !Shopify.designMode) return;
  try {
    
    class StickyProduct extends HTMLElement {
        constructor() {
            super();
            this.visible = false;
        }
        connectedCallback() {
            // target
            const indexProduct = document.querySelector("div.index-product");
            if(!indexProduct) return;

            const productSubmit = indexProduct.querySelector(".product__submit");
            if(!productSubmit) return;

            const targetY = productSubmit.getBoundingClientRect().top + window.scrollY; 
            const triggerScroll = targetY * 1; // el doble

            const onScroll = () => {
            const current = window.scrollY;
            if(current >= triggerScroll && !this.visible){
                this.visible = true;
                this.classList.add("show");
            } else if(current < triggerScroll && this.visible){
                this.visible = false;
                this.classList.remove("show");
            }
            };

            window.addEventListener("scroll", onScroll);
        }
    } 

    customElements.define("sticky-product", StickyProduct);

  } catch(e) { console.error(e); }
})();
})();
